module.exports = __webpack_public_path__ + "static/media/meter-circle.9a0897e3.svg";